<!--实时值-->
<template>


  <div class="myvirtualDeviceRTValue">
    <div class="con">
      <div class="tree-left">
        <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
      </div>
      <div class="right-table">
        <div class="Files-top">
          <div class="ic-left">
            <span>实时列表</span>
          </div>
          <div class="btns">
            <el-button @click="downloadExcel" type="primary" class="last-el-button">导出</el-button>
          </div>
        </div>
        <div class="search-input-btn" style="width:100%">
          <div class="input-small">
            <span>应用类型组：</span>
            <el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择">
              <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
              <el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="Files-table" :style="{'height':heights+'px'}">
          <el-table :data="nowPage" stripe :max-height="heights - 20" style="width: 100%">
            <el-table-column label="序号" width="90" align="center">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column type="index" width="90" label="序号"></el-table-column> -->
            <el-table-column prop="devicename" label="设备名称" width="300"> </el-table-column>
            <el-table-column prop="variablename" label="变量名称" width="300"> </el-table-column>
            <el-table-column prop="value" label="实时值" width="220" align="right"> </el-table-column>
            <el-table-column prop="getTime" label="变化时间" width="200" align="center"> </el-table-column>
            <!-- <el-table-column prop="deviceState" label="通讯状态" align="center"> </el-table-column> -->
            <el-table-column label="通讯状态" align="center">
              <template #default="{row}">
                <div class="patrol public-flex" v-if="row.deviceState =='正常'">
                  <p></p><span>正常</span>
                </div>
                <div class="rush public-flex" v-else>
                  <p></p><span>{{row.deviceState}}</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column v-for='item in columns' :prop="item.key" align='center' :label="item.name" :key="item.key"
                          sortable></el-table-column> -->

          </el-table>
        </div>
        <div class="divider-line"></div>
        <div class="paging">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
            :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>

        </div>



      </div>
    </div>
  </div>

</template>

<script type="text/javascript">
  isempty()
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  export default {
    components: {
      elUnitTree
    },
    props: [],
    data () {
      return {
        heights: document.getElementById('app').clientHeight-300,
        apptypeValue: [],
        nowIndex: 0,
        nowApptypeGroups: [],
        from2name: {},
        columns: [{
          name: '设备名称',
          key: 'devicename'
        },{
          name: '变量名称',
          key: 'variablename'
        },{
          name: '实时值',
          key: 'value',
          getTdStyleMethod (column,index,value) {
            if(parseFloat(value)==NaN) {
              return {
                'color': '#FF9900'
              }
            }
          }
        },{
          name: '变化时间',
          key: 'getTime'
        },{
          name: '通讯状态',
          key: 'deviceState',
          getTdStyleMethod (column,index,value) {
            if(value=='正常') {
              return {
                'color': 'rgb(103, 194, 58)'
              }
            } else if(value=='取消') {
              return {
                'color': '#999999'
              }
            }
          }
        }],
        total: 0,
        currentPage: 1,
        currentSize: 15,
        nowVirtualDeviceList: []
      }
    },
    created () {
      debugPage=this
      //直接全选
      

    },
    mounted () {
      this.apptypeValue=this.nowSelectAppTypeGroupIds
    },
    destroyed () {
      this.realTimeValueStore.commit("removeKeys",this.nowVariableNames)
    },
    computed: {
      nowSelectAppTypeGroupIds () {
        return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
      },
      // nowVirtualDeviceList () {
      //   return this.$store.deviceStore.state.nowVirtualDeviceList
      // },
      variableStore () {
        return this.$store.variableStore
      },
      deviceStore () {
        return this.$store.deviceStore
      },
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },
      variableTree () {
        if(isempty(this.nowVirtualDeviceList)) {
          return []
        }
        var variableTreeArr=[]
        this.nowVirtualDeviceList.forEach(item => {
          var variableTree=[]
          if(item.type=="virtualDevice") {
            if(variableTree.length==0) {
              variableTree=this.variableStore.getters.getVariableTree(item.no)
            }
          }
          variableTree.forEach(tree => {
            tree.devicename=item.name
          })
          variableTreeArr.push(variableTree)
        })
        var result=[]
        variableTreeArr.forEach(item => {
          result=result.concat(item)
        })
        return result
      },
      apptypeGroups () {
        //debugger
        //所有已选中的设备所具有的变量类型组
        var list=[]
        var apptypeGroupIds=[]
        this.variableTree.forEach(apptypeGroup => {
          if(!apptypeGroupIds.includes(apptypeGroup.id)) {
            apptypeGroupIds.push(apptypeGroup.id)
            list.push(apptypeGroup)
          }
        })
        //排序
        let list2=[]
        list.forEach(item => {
          if(item.name!="门限值") {
            list2.push(item)
          }
        })
         //排序
        list2.sort((a,b) => {
          return a.serialnum-b.serialnum
        })
        
         let idList=[]
          list2.forEach(item => {
            idList.push(item.id)
          })
          this.apptypeValue=idList
        return list2
        // return list2.sort((a,b) => {
        //   return a.serialnum-b.serialnum
        // })
      },
      nowVariableNames () {
        //当前应该显示的变量fromname列表
        var ag=this.nowApptypeGroups.map(item => {
          return item.id
        })
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.id)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            this.from2name[i.fromName]=i.name+'('+item.unit+')'
            v2.push(i.fromName)
          })
        })

        return v2
      },
      nowVariableList () {
        //当前应该显示的变量fromname列表
        var ag=this.nowApptypeGroups.map(item => {
          return item.id
        })
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.id)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            i.devicename=item.devicename
            v2.push(i)
          })
        })
        v2.sort((a,b) => {
          return a.typeNo-b.typeNo
        })
        return v2
      },
      pageLen () {
        return this.dataList.length<this.currentSize? this.dataList.length:this.currentSize
      },
      nowPage () {
        // 按照页码来返回当前应该显示的列表
        this.total=this.dataList.length
        var list=this.dataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
        return list
      },
      dataList () {
        //获取值
        var vl=this.realTimeValueStore.getters.getValue(this.nowVariableNames)
        var deviceList=this.nowVariableNames.map(item => item.substring(0,item.indexOf('.'))).distinct()
        var deviceStateMap=this.realTimeValueStore.getters.getDeviceState(deviceList)
        var v2=this.realTimeValueStore.getters.getTime(this.nowVariableNames)
        //获取当前设备状态
        return this.nowVariableNames.map((item,index) => {
          var value=this.realTimeValueStore.getters.getText(item,vl[index])
          var deviceState='--'
          switch(deviceStateMap[item.substring(0,item.indexOf('.'))]) {
            case 0:
              deviceState='取消'
              break
            case 1:
              deviceState='正常'
              break
          }
          var getTime=v2[index]!=undefined? new Date(parseInt(v2[index])).format('yyyy-MM-dd hh:mm:ss'):'--'
          if(isNaN(parseFloat((vl[index])))||isnull(parseFloat((vl[index])))) {
            value="- -"
          }
          var name=this.from2name[item]? this.from2name[item]:item
          let deviceName=''
          //这样拿貌似也不行，里面数据有问题this.nowVariableList[index].fromName.split('.')[0]
          this.nowVariableList.forEach(item2 => {
            if(item2.fromName==item) {
              //deviceName = item2.fromName.split('.')[0]
              deviceName=item2.deviceName;
            }
          })
          return {
            devicename: deviceName,
            variablename: name.subByFirstChar("."),
            value,
            getTime,
            deviceState,
          }
        })
      }
    },
    watch: {
      nowVariableNames (nv,ov) {
        this.realTimeValueStore.commit("removeKeys",ov)
        this.realTimeValueStore.commit("addKeys",nv)
      },
      apptypeValue (nv,ov) {
        this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',nv)
        let list=[]
        if(!isempty(nv)) {
          nv.forEach(item => {
            this.apptypeGroups.forEach(item2 => {
              if(item==item2.id) {
                list.push(item2)
              }
            })
          })
        }
        this.nowApptypeGroups=list
      },
      nowIndex () {
        this.nowPage
      }
    },
    methods: {
      checkFun (val) {
        this.nowVirtualDeviceList=val
      },
      //下载excel文件
      downloadExcel () {
        let title='<thead><tr>'
        title+='<th colspan=6>'+new Date().formatByTime('-')+' 实时值'+'</th>'
        title+='</tr></thead>'
        let aa=document.getElementsByTagName('thead')[0];//头部表达
        let bb=document.getElementsByTagName('tbody')[0];//列表内容
        let table=title+aa.innerHTML+bb.innerHTML
        exportToExcel(table,"实时值报告")
      },
      selectAll () {
        //全选 先判断是否有选中的，有选中就清空
        if(this.apptypeValue.length==1) {
          this.nowApptypeGroup=this.apptypeGroups
          let idList=[]
          this.apptypeGroups.forEach(item => {
            idList.push(item.id)
          })
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',idList)
          this.apptypeValue=idList
        } else {
          this.nowApptypeGroup=[]
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',[])
          this.apptypeValue=[]
        }
      },
      checkAppGroup (item) {
        //选中了app应用组
        this.nowApptypeGroups=item
      },

      //分页功能 
      handleSizeChange (val) {
        this.currentSize=val;
        // this.getList()
      },
      handleCurrentChange (val) {
        this.nowIndex=val-1;
        // this.getList()
      }

    }
  }
</script>

<style scoped lang="scss">
  .myvirtualDeviceRTValue {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // 正常
      .patrol {
        p {
          width: 8px;
          height: 8px;
          background-color: #0DAE88;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #0DAE88;
        }
      }

      // 非正常
      .rush {
        p {
          width: 8px;
          height: 8px;
          background-color: #FF1D1D;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #FF1D1D;
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;

        .mycharts {
          display: flex;

          .charts-left {
            width: 35%;
          }

          .charts-right {
            width: 70%;
          }
        }
      }
    }
  }
</style>